import { useState } from 'react'
import { Link } from 'react-router-dom'
import type { AgentTaskResult } from '../pages/AgentDetailPage'
import './AgentDetailResults.css'

interface AgentDetailResultsProps {
  totalScore: number
  failureCount: number
  passTasks: AgentTaskResult[]
  failTasks: AgentTaskResult[]
  dsqTasks: AgentTaskResult[]
  disagreeTasks: AgentTaskResult[]
}

function StatusSection({ label, statusClass, tasks, defaultExpanded }: {
  label: string
  statusClass: string
  tasks: AgentTaskResult[]
  defaultExpanded?: boolean
}) {
  const [expanded, setExpanded] = useState(defaultExpanded ?? false)

  return (
    <div className="agent-status-section">
      <button
        className="agent-status-section-header"
        onClick={() => setExpanded(!expanded)}
        data-testid={`agent-status-${statusClass}-toggle`}
      >
        <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
          style={{ transform: expanded ? 'rotate(90deg)' : 'none', transition: 'transform 0.15s ease', flexShrink: 0 }}>
          <path d="M6 4l4 4-4 4" />
        </svg>
        <span className={`agent-status-label ${statusClass}`}>{label}</span>
        <span className="agent-status-count">{tasks.length}</span>
      </button>
      {expanded && (
        <ul className="agent-status-list">
          {tasks.map((t, i) => (
            <li key={i} className="agent-status-item">
              <Link to={`/failures/${t.failure_id}`} className="agent-status-link">
                <span className="agent-status-short-id">{t.failure_short_id}</span>
                <span className="agent-status-title">{t.failure_title}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

function AgentDetailResults({ totalScore, failureCount, passTasks, failTasks, dsqTasks, disagreeTasks }: AgentDetailResultsProps) {
  return (
    <section className="agent-detail-section">
      <h2 className="agent-detail-section-title">Results</h2>
      <div className="agent-score-summary">
        <span className="agent-score-item">
          <span className="agent-score-label">Score</span>
          <span className={`agent-score-value ${totalScore > 0 ? 'positive' : totalScore < 0 ? 'negative' : ''}`}>
            {totalScore > 0 ? '+' : ''}{totalScore}
          </span>
        </span>
        <span className="agent-score-item">
          <span className="agent-score-label">Failures</span>
          <span className="agent-score-value">{failureCount}</span>
        </span>
      </div>

      <StatusSection label="Pass" statusClass="pass" tasks={passTasks} />
      <StatusSection label="Fail" statusClass="fail" tasks={failTasks} />
      <StatusSection label="DSQ" statusClass="dsq" tasks={dsqTasks} />
      <StatusSection label="Disagree" statusClass="disagree" tasks={disagreeTasks} />
    </section>
  )
}

export default AgentDetailResults
